// slick
$(function() {
  $('.top-movie-list').slick({
    speed: 500,
    centerMode: true,
    centerPadding: '19%',
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        }
      },
    ]
  });
});
